import { gql } from '@apollo/client';

export default gql`
  mutation destroyWarrantyNote($input: WarrantyNoteDestroyInput!) {
    destroyWarrantyNote(input: $input) {
      clientMutationId
      warrantyNote {
        id
        message
        warrantyId
        adminUserId
        partnerUserId
        adminUser {
          id
          firstName
          lastName
        }
        partnerUser {
          id
          firstName
          lastName
        }
        createdAt
        updatedAt
      }
    }
  }
`;
